const ACTIVITI_PREFIX = 'activiti$';

export function removeWfDefKeyPrefix(defKey: string) {
  if (defKey.startsWith(ACTIVITI_PREFIX)) {
    return defKey.substring(ACTIVITI_PREFIX.length);
  }
  return defKey;
}
